/**
 * BrandMark \u2014 the official Lone Star Counsel full brand lockup.
 *
 * Renders the transparent-background PNG of the LSC monogram stacked
 * above the "LONE STAR \u2605 COUNSEL / ATTORNEYS & ADVISORS" wordmark. Sits
 * cleanly on both ivory and navy surfaces (fully transparent background).
 *
 * Props kept for backwards compat: variant, showUrl, taglineText.
 * size accepted values: sm | md | lg | xl | hero (pixel heights).
 */

const SIZE_HEIGHTS = {
  sm: 56,
  md: 76,
  lg: 104,
  xl: 144,
  hero: 200,
};

// Source PNG is 809 \u00d7 978 after transparent-background crop.
const LOGO_ASPECT = 809 / 978;

export default function BrandMark({
  variant = "light",
  size = "md",
  showUrl = true,
  className = "",
  taglineText,
}) {
  void variant; void showUrl; void taglineText;
  const height = SIZE_HEIGHTS[size] || SIZE_HEIGHTS.md;
  const width = Math.round(height * LOGO_ASPECT);

  return (
    <img
      src="/brand/lsc-full-logo-transparent.png"
      alt="Lone Star Counsel \u2014 Attorneys & Advisors"
      width={width}
      height={height}
      className={`inline-block object-contain ${className}`}
      style={{ height, width }}
      loading="eager"
      data-testid="brand-mark"
    />
  );
}
